import Application from "../../Application";
import { ICredentialsService } from "../../service/authentication/CredentialsService";
import { IUserService } from "../../service/user/UserService";

export default class CheckLoginStatusInteractor {
  private application: Application;
  private credentialsService: ICredentialsService;
  private userService: IUserService;

  constructor(application, credentialsService, userService) {
    this.application = application;
    this.credentialsService = credentialsService;
    this.userService = userService;
  }

  async execute() {
    const isLoggedIn = await this.credentialsService.getIsLoggedIn();
    if (!isLoggedIn) {
      try {
        await this.userService.getUserProfile();
        return true;
      } catch (error) {
        return false;
      }
    }
    return isLoggedIn;
  }
}
